import { ShadcnButton } from "@components/items/display/ShadcnButton";
import TranslatedText from "@components/items/display/TranslatedText";
import { useNavigateToTab } from "@utils/hooks/useNavigateToHome";
import { TabResponsibility } from "@wajeez/wajeez.microservices/dist/api.Server.clients";

function EmptySkills() {
  const navigateToB2BSkills = useNavigateToTab(TabResponsibility.B2BSkills);
  return (
    <div className="flex h-[50vh] w-full flex-col items-center justify-center gap-y-4">
      <TranslatedText
        text={`my-skills.titles.${"start your journey towards a new skill"}`}
        className="text-[32px] font-bold text-b2b-primary dark:text-white"
      />
      <TranslatedText
        text={`my-skills.titles.${"discover new aspects of yourself by developing your mind and enhancing your skills"}`}
        className="text-[16px] font-medium text-[#898A8D]"
      />
      <ShadcnButton
        className="bg-b2b-primary hover:bg-b2b-primary/85"
        onClick={navigateToB2BSkills}
      >
        <TranslatedText
          text={`my-skills.buttons.${"start a skill now"}`}
          className="text-[17px] font-medium text-white"
        />
      </ShadcnButton>
    </div>
  );
}

export default EmptySkills;
